import { useParams } from 'react-router-dom';

export const useClientId: () => number = () => {
  const { clientId } = useParams<{ clientId: string }>();
  return parseInt(clientId, 10);
};
